module.exports = __webpack_public_path__ + "5c4c016bdb37f3c25c7cd59bc7fcdfa6.mp4";